import React from 'react'

const Fantasy11 = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Find the meanings of the following words and phrases from a dictionary and make sentences by using them.</p>
        <p><strong>a. peep into : </strong>To look quickly and secretly into a place or through an opening.</p>
        <p>She tried to peep into the room to see what was happening without being noticed.</p>
        <br/>
        <p><strong>b. pop down : </strong>To go somewhere quickly or for a short time, usually nearby.</p>
        <p>I'll just pop down to the store to buy some milk.</p>
        <br/>
        <p><strong>c. remarkable : </strong>Very unusual or special; worth noticing or attention.</p>
        <p>Her performance in the competition was truly remarkable.</p>
        <br/>
        <p><strong>d. hedge : </strong>A row of bushes or small trees planted close together, usually as a boundary or fence.</p>
<br/>      
  <p><strong>e. wonder :</strong>To think about something with curiosity or doubt.</p>
        <p>I wonder what time the movie starts tonight.</p>
        <br/>
        <p><strong>f. tumble :</strong>To fall suddenly, clumsily, or headlong.</p>
        <p>The boy took a tumble while learning to ride his bike.</p>
        <br/>
        <p><strong>g. doze off : </strong>To fall asleep lightly or briefly, often unintentionally, especially when you are tired.</p>
        <p>I started to doze off during the boring lecture.</p>
        <br/>
        <p><strong>h. earnestly : </strong>In a serious and sincere way, showing deep feeling or strong intention.</p>
        <p>He spoke earnestly about the need to protect the environment.</p>
        <br/>
        <p><strong>i. tiny : </strong>Very small in size or amount.</p>
    
      
        <p>The kitten was so tiny that it fit in the palm of my hand.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Match the words below with their opposites.</p>
        <p>a. beginning = ending</p>
        <p>b. stupid = clever</p>
        <p>c. natural = artificial</p>
        <p>d. disappointment = happiness</p>
        <p>e. ignorant = educated</p>
        <p>f. anxiously = calmly</p>
      </div>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>A. Answer these questions.</p>
        <p className='question' >a. What did Alice do while her sister was reading a book?</p>
        <p>= Alice fell asleep while her sister was reading a book.</p>
        <p className='question'>b. Why did Alice run across the field after the Rabbit?</p>
        <p>= Alice ran across the field after the Rabbit because she was curious to know more about the rabbit, which she had never seen before.</p>
        <p className='question'>c. Why didn't she like to drop the jar? What did she do with it?</p>
        <p>= She didn't want to drop the jar because she was afraid it might hurt someone underneath. So, she carefully placed it on one of the cupboards.</p>
        <p className='question'>d. What idea came to her mind when she saw a tiny golden key?</p>
        <p>= When she saw the tiny golden key, she thought about using it to open one of the doors in the hall.</p>
        <p className='question'>e. What was written on the bottle that she found? Did she follow what it said?</p>
        <p>= The bottle she found had “DRINK ME” written on it, and she did follow the instruction.</p>
        <p className='question'>f. Alice was fond of pretending to be two people. Who were they?</p>
        <p>= Alice was fond of pretending to be two people: herself and her friend Alice.</p>
        <p className='question'>g. Why did she want to eat the cake that she found?</p>
        <p>Alice wanted to eat the cake she found because she hoped it would make her grow bigger.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Put these sentences in the right order as they happen in the story.</p>
        <p>f. Alice saw a White Rabbit and ran after him.</p>
        <p>c. Alice fell down a rabbit hole.</p>
        <p>b. Alice found a small key and unblocked a very small door.</p>
        <p>d. Alice drank something from a bottle and got very small door.</p>
        <p>e. Alice tried to climb a table leg to get the key again.</p>
        <p>a. Alice ate a small cake, which said “EAT ME”</p>
      </div>
      <hr/>
      <div>
        <h3>Critical thinking</h3>
        <p className='question'>a. “Down the rabbit hole” is a sort of writing called fantasy. On the basis of your reading of the story point out some special elements of this kind of writing?</p>
        <p>= Fantasy refers to stories that involve imagination and things that are not real. Unlike stories based on facts, fantasy stories include events and characters that do not follow the rules of the real world. They often have magical or supernatural elements, such as magic spells, talking animals, or magical creatures.
</p><p>
Fantasy stories are usually set in the past, often in times like the medieval era, where there are castles, knights, kings, and magical swords. The characters live in worlds where technology is limited, but magic exists and helps them.
</p><p>
The idea of fantasy has been around for many centuries, inspired by myths, legends, and fairy tales. However, modern fantasy stories started to develop during the Victorian era, when writers began to create their own unique magical worlds instead of just retelling old stories.
</p><p>
In summary, fantasy writing takes readers to imaginative places with magic, strange creatures, and adventures beyond the real world.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Is it good to imagine of things which are not possible to achieve in reality? Explain.</p>
        <p>= Imagination is the ability to create pictures and ideas in our mind that we don't see with our five senses. It helps us dream and think about things we want, even if they are not real yet.
    </p><p>
Many people use their imagination to picture a better life or to think about what might happen in the future. When we practice using our imagination, it helps us become more creative. This means we can have better ideas and understand what we really want in life.
</p><p>
Imagination also helps us build confidence and can reduce stress, which makes us feel healthier and happier. It clears our minds from confusing thoughts and helps us focus.
</p><p>
By imagining, we can explore different possibilities and shape the future we want. So, even if some things seem impossible now, imagining them is good because it helps us grow, plan, and sometimes even make those dreams come true.
</p>
      </div>
      <hr/>
      <div>
        <p className='question'>c. Do you talk to yourself when you are in a trouble? If yes, how does it help you?</p>
        <p>= Yes, I do talk to myself when I am in trouble. Actually, I talk to myself almost every day! I'm not exactly sure how long I have been doing it, but I know I've been doing it for many years, and I actually like it.
</p><p>
Talking to myself helps me in many ways. I can say things to myself that I might not say to anyone else because no one understands me better than I do. I can say anything without being judged! I think self-talk is good because it doesn't take much effort like keeping a diary does. I usually talk to myself when I'm thinking about ideas, making decisions, or when I need some encouragement.
</p><p>
Self-talk makes me feel better because it feels like someone is there with me. It helps me make decisions easier and motivates me to do things I might be avoiding. In short, I use self-talk to manage strong feelings like anger, sadness, confusion, and stress, and to solve my personal problems.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>Describe a strange dream that you have seen recently.</p>
        <p>= I was around 12 years old when I had a very strange and ridiculous dream. In the dream, I was in a room on a high floor of a tall building with five or six friends. We were looking out of the window and saw many other tall buildings around us. We were having fun, enjoying the view.
</p><p>
Suddenly, the ground started to shake. Then, in the distance, we saw a black figure moving toward us. As it got closer, we saw that it was a giant person, much taller than the buildings. This person was wearing all black clothes and a black mask. He started destroying every building he came near.
</p><p>
The giant figure came close to our building, and we all became very scared, running around the room. He destroyed the ceiling above us and the room above ours. Then he looked straight at me, and at that moment, I woke up.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>B. Express your wishes in the following situations in three different ways. Use I wish/If only…….</p>
        <p>a. You don't have a mobile phone (You need one).</p>
        <p>I wish I had a mobile phone.</p>
        <p>I wish I won a mobile phone.</p>
        <p>I wish I won a mobile phone.</p>
        <br/>
        <p>b. You don't know the answer of a question from the lesson.</p>
        <p>I wish I had read the lesson more carefully.</p>
        <p>I wish someone could help me with the answer.</p>
        <p>I wish I understood the topic better.</p>
        <br/>
        <p>c. You can't play the guitar.</p>
        <p>I wish I knew how to play the guitar.</p>
        <p>I wish someone could teach me to play it.</p>
        <p>I wish I had learned it earlier.</p>
        <br/>
        <p>d. It's cold</p>
        <p>I wish the weather were warmer.</p>
        <p>I wish I had brought a jacket.</p>
        <p>I wish the sun would come out.</p>
        <br/>
        <p>e. You are feeling sick.</p>
        <p>I wish I felt better.</p>
        <p>I wish I didn't have to go out today.</p>
        <p>If only I had taken better care of myself.</p>
        <br/>
        <p>f. You live in a crowded city.</p>
        <p>I wish I lived in a quieter place.</p>
        <p>I wish the city weren't so crowded.</p>
        <p>If only I could move to the countryside.</p>
        <br/>
        <p>g. You feel lonely.</p>
        <p>I wish I had someone to talk to.</p>
        <p>I wish I didn't feel so alone.</p>
        <p>If only I had more friends around me.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>C. Rewrite the following sentences making correction if necessary.</p>
        <p>a. I wish my father bought me a bike.</p>
        <p>= I wish my father would buy me a bike.</p>
        <br/>
        <p>b. I wish I would write poems.</p>
        <p>= I wish I could write poems.</p>
        <br/>
        <p>c. I wish I could remember her name.</p>
        <p>= I wish I could remember her name.</p>
        <br/>
        <p>d. I wish I had a good job.</p>
        <p>= I wish I had a good job.</p>
        <br/>
        <p>e. I wish I would be rich.</p>
        <p>= I wish I were rich.</p>
      </div>
    </div>
  )
}

export default Fantasy11
